import api from './api';

const appointmentService = {
  // Get all appointments with optional filters
  getAllAppointments: async (params = {}) => {
    const response = await api.get('/appointments', { params });
    return response.data;
  },

  // Get single appointment by ID
  getAppointmentById: async (id) => {
    const response = await api.get(`/appointments/${id}`);
    return response.data;
  },

  // Create new appointment
  createAppointment: async (appointmentData) => {
    const response = await api.post('/appointments', appointmentData);
    return response.data;
  },

  // Update appointment
  updateAppointment: async (id, appointmentData) => {
    const response = await api.put(`/appointments/${id}`, appointmentData);
    return response.data;
  },

  // Delete appointment
  deleteAppointment: async (id) => {
    const response = await api.delete(`/appointments/${id}`);
    return response.data;
  },

  // Update appointment status
  updateAppointmentStatus: async (id, status) => {
    const response = await api.patch(`/appointments/${id}/status`, { status });
    return response.data;
  },

  // Get appointments by date
  getAppointmentsByDate: async (date) => {
    const response = await api.get('/appointments/by-date', { params: { date } });
    return response.data;
  },

  // Get today's appointments
  getTodayAppointments: async () => {
    const response = await api.get('/appointments/today');
    return response.data;
  },

  // Get appointments for month (for calendar)
  getMonthAppointments: async (year, month) => {
    const response = await api.get('/appointments/month', { 
      params: { year, month } 
    });
    return response.data;
  },

  // Get appointment statistics
  getAppointmentStats: async () => {
    const response = await api.get('/appointments/stats');
    return response.data;
  },
};

export default appointmentService;